import type { Point2d } from ".."
import type { InsetEdge } from "./getInsetEdges"
import type { SerialTag } from "./linkAllInsetEdges"
import type { InsetLinkEdge } from "./linkInsetEdges"
import { reducePairings } from "../../matching/reducePairings"
import { doSegmentsIntersect, whereDoSegmentsIntersect } from "../collision"

export const findAllIntersections = (options: {
  insetsAndLinks: ((InsetEdge & SerialTag) | (InsetLinkEdge & SerialTag))[]
}): {
  procedure: { intersections: (Point2d & SerialTag)[] }
} => {
  const { insetsAndLinks } = options
  const intersections = reducePairings({
    elements: insetsAndLinks,
    produceResult: (edgeA, edgeB, { a, b }) => {
      if (doSegmentsIntersect(edgeA, edgeB)) {
        const logging = false
        // edgeA.alphaCode === `B` && edgeB.alphaCode === `C`

        const intersection = whereDoSegmentsIntersect(edgeA, edgeB, {
          logging,
        }) as Point2d

        const alphaCode = edgeA.alphaCode + edgeB.alphaCode

        return {
          alphaCode,
          lowerBound: a,
          upperBound: b,
          range: b - a,
          ...intersection,
        } as Point2d & SerialTag
      }

      return null
    },
  })

  return { procedure: { intersections } }
}
